import "core-js/modules/es7.object.values";
import "core-js/modules/es6.array.from";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.set";
import axios from 'axios';
import { MessageBox, Message } from 'element-ui';
import store from '@/store';
import { getToken } from '@/utils/auth';
import { setCookie } from "./cookie";
import { getApiLanguageCode } from '@/i18n';

// create an axios instance
var service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  // url = base url + request url
  withCredentials: true,
  // send cookies when cross-domain requests
  timeout: 50000 // request timeout
});

// request interceptor
service.interceptors.request.use(function (config) {
  // do something before request is sent

  // config.headers['content-type'] = 'application/x-www-form-urlencoded'
  if (store.getters.token) {
    // let each request carry token
    // ['X-Token'] is a custom headers key
    // please modify it according to the actual situation
    var token = getToken();
    if (token) {
      config.headers['Authorization'] = ' Token ' + token;
      setCookie('token', token, 1);
    }
  }
  // 根据环境变量设置不同的业务线请求头
  // 国内版本使用 XMOD，海外版本使用 OXMOD
  var isOversea = process.env.VUE_APP_IS_OVERSEA === 'true';
  config.headers['Product-Line'] = isOversea ? 'OXMOD' : 'XMOD';
  config.headers['Client-Language'] = getApiLanguageCode();
  return config;
}, function (error) {
  // do something with request error
  console.log(error); // for debug
  return Promise.reject(error);
});

// response interceptor
service.interceptors.response.use(
/**
 * If you want to get http information such as headers or status
 * Please return  response => response
*/

/**
 * Determine the request status by custom code
 * Here is just an example
 * You can also judge the status by HTTP Status Code
 */
function (response) {
  var res = response.data;
  return res;
}, function (error) {
  if (error.response) {
    var status = error.response.status;
    if (status === 401) {
      // to re-login
      MessageBox.confirm('登录已过期,是否重新登录', 'Confirm logout', {
        confirmButtonText: '重新登录',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        store.dispatch('user/resetToken').then(function () {
          location.reload();
        });
      });
    }
  }
  if (error.response.status === 400) {
    message = error.response.data;
    var msg_ = new Set();
    dealMsg(msg_, message);
    msg_ = Array.from(msg_);
    if (error.response.data.msg) {
      message = error.response.data.msg;
      console.log(message);
    }
    Message({
      message: msg_.join(' '),
      type: 'error',
      duration: 7 * 1000
    });
  } else {
    console.log(error.response.data); // for debug
    var message = error.response.data;
    if (error.response.data.msg) {
      message = error.response.data.msg;
    }
    Message({
      message: message,
      type: 'error',
      duration: 7 * 1000
    });
  }
  return Promise.reject(error);
});
export default service;
function dealMsg(msg_, message) {
  for (var _i = 0, _Object$values = Object.values(message); _i < _Object$values.length; _i++) {
    var val = _Object$values[_i];
    if (val.constructor === Object || val.constructor === Array) {
      console.log(val);
      dealMsg(msg_, val);
    } else {
      msg_.add(val);
    }
  }
}